/**
 * Ownership periods are valid when their splits total 100 (legacy points) or
 * 100000 (basis points). The scale is a property of the whole period.
 */
export function getOwnerSplitBase(
  members: readonly { split?: number | null }[]
) {
  return members.reduce((total, { split }) => total + (split ?? 0), 0) === 100
    ? 100
    : 100_000;
}
